import { AgeGroup } from 'types'

export const getAgeGroup = (ageGroup: AgeGroup): string => {
  switch (ageGroup) {
    case 'Men':
      return 'Männer'
    case 'Women':
      return 'Frauen'
    case 'AYouth':
      return 'A-Jugend'
    case 'BYouth':
      return 'B-Jugend'
    case 'CYouth':
      return 'C-Jugend'
    case 'DYouth':
      return 'D-Jugend'
    case 'EYouth':
      return 'E-Jugend'
    case 'FYouth':
      return 'F-Jugend'
    case 'Minis':
      return 'Minis'
    default:
      return ''
  }
}
